<template>
  <div class="container">
    <h4 v-if="defaultQuery">{{ pColumnTitle ? `${pColumnTitle}-${columnTitle}` : columnTitle }}</h4>
    <div class="selection" v-if="defaultQuery">
      <a-input v-model="keyword" @change="search" :placeholder="$t('admin.content.news.list.searchPlaceholder')">
        <img slot="prefix" :src="require('@/assets/icons/icon_ss.png')" />
        <img class="clear" v-if="keyword" slot="suffix" @click="keyword = undefined, search()" :src="require('@/assets/icons/icon_gb.png')" />
      </a-input>
      <a-button type="primary" @click="create">{{ $t('admin.content.news.list.create') }}{{ columnTitle }}</a-button>
    </div>
    <a-table
      v-if="defaultQuery"
      row-key="id"
      :columns="columns"
      :data-source="data"
      :locale="locale"
      @change="handleTableHeaderChange">
      <template slot="operate" slot-scope="text, record">
        <div class="operate">
          <span @click="edit(record)">{{ $t('admin.content.news.list.actions.edit') }}</span>
          <span v-if="!record.isAdmin" @click="delModal(record.id)">{{ $t('admin.content.news.list.actions.delete') }}</span>
        </div>
      </template>
    </a-table>
    <div v-else class="noData">
      <img src="@/assets/img/no_data_news.png" alt="">
      <span>{{ $t('admin.content.news.list.noData') }}{{ columnTitle }}</span>
      <a-button type="primary" @click="create">{{ $t('admin.content.news.list.create') }}{{ columnTitle }}</a-button>
    </div>
    <Pagination
      class="list-pagination"
      :pagination.sync="pagination"
      @handleTableChange="handleTableChange" />
    <TipModal
      @ok="del"
      :visible="delVisible"
      @cancel="delVisible = false"
      :desc="`
        <p>${$t('admin.content.news.list.deleteConfirm.title')}</p>
        <p class='placeholder'>${$t('admin.content.news.list.deleteConfirm.content')}</p>`" />
  </div>
</template>

<script>
import {
  newsDel,
  newsList
} from '@/api/admin'
import { getListIndex } from '@/utils/other'
import { nameMap } from '@/utils/map'
import TipModal from '@/components/tipModal/index.vue'
import Pagination from '@/components/pagination/index.vue'
import Empty from '@/components/Empty/index.vue'

export default {
  components: {
    TipModal,
    Pagination
  },
  data() {
    return {
      delId: undefined,
      delVisible: false,
      keyword: '',
      columns: [
        {
          title: this.$t('admin.content.news.list.columns.id'),
          dataIndex: 'index',
          key: 'index'
        },
        {
          title: this.$t('admin.content.news.list.columns.title'),
          dataIndex: 'title',
          width: 500
        },
        {
          title: this.$t('admin.content.news.list.columns.status'),
          width: 120,
          dataIndex: 'statusName',
          filterIcon: filtered => {
            if (filtered) {
              return <img style="width: 1em; height: 1em" src={require('@/assets/icons/icon_zt_x.png')} />
            }
            return <img style="width: 1em; height: 1em" src={require('@/assets/icons/icon_zt.png')} />
          },
          filters: [
            { text: this.$t('admin.content.news.list.filters.status.open'), value: '开启' },
            { text: this.$t('admin.content.news.list.filters.status.close'), value: '关闭' }
          ]
        },
        {
          title: this.$t('admin.content.news.list.columns.createdAt'),
          dataIndex: 'createdAt'
        },
        {
          title: this.$t('admin.content.news.list.columns.updatedAt'),
          dataIndex: 'updatedAt'
        },
        {
          title: this.$t('admin.content.news.list.columns.recommend'),
          width: 140,
          dataIndex: 'recommendName',
          filterIcon: filtered => {
            if (filtered) {
              return <img style="width: 1em; height: 1em" src={require('@/assets/icons/icon_zt_x.png')} />
            }
            return <img style="width: 1em; height: 1em" src={require('@/assets/icons/icon_zt.png')} />
          },
          filters: [
            { text: this.$t('admin.content.news.list.filters.recommend.yes'), value: '推荐' },
            { text: this.$t('admin.content.news.list.filters.recommend.no'), value: '未推荐' }
          ]
        },
        {
          title: this.$t('admin.content.news.list.columns.operations'),
          dataIndex: 'operate',
          scopedSlots: { customRender: 'operate' }
        }
      ],
      data: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      isDefaultQuery: true,
      columnTitle: this.$route.query.columnTitle,
      pColumnTitle: this.$route.query.pColumnTitle,
      text: this.$t('emptyText.noData'),
      desc: this.$t('emptyText.searchTip'),
      locale: {
        emptyText: () => <Empty text={this.text} desc={this.desc} />
      },
    }
  },
  computed: {
    defaultQuery() {
      return !(this.pagination.total === 0 && !this.keyword && this.isDefaultQuery)
    }
  },
  // 页面显示时候触发
  watch: {
    $route() {
      this.columnId = this.$route.query.columnId
      this.columnTitle = this.$route.query.columnTitle
      this.getNewsList()
    }
  },
  methods: {
    handleTableChange() {
      this.getNewsList()
    },
    handleTableHeaderChange(p, filters) {
      const filterKey = [['statusName', 'status'], ['recommendName', 'isRecommend']]
      const result = {}
      filterKey.forEach(item => {
        if (filters[item[0]]) {
          result[item[1]] = filters[item[0]].map(f => {
            if (f === '开启' || f === '未推荐') {
              return 1
            }
            return 2
          })
          result[item[1]] = result[item[1]].length > 1 ? '' : result[item[1]][0]
        }
      })
      this.isDefaultQuery = false
      this.getNewsList(result)
    },
    create() {
      this.$router.push({
        name: 'newsAdd',
        query: {
          columnId: this.columnId,
          columnTitle: this.columnTitle
        }
      })
    },
    search() {
      this.pagination.page = 1
      this.getNewsList()
    },
    edit(record) {
      this.$router.push({
        name: 'newsAdd',
        query: {
          id: record.id,
          columnId: this.columnId,
          columnTitle: this.columnTitle
        }
      })
    },
    delModal(id) {
      this.delVisible = true
      this.delId = id
    },
    del() {
      newsDel({ id: this.delId }).then(res => {
        if (res.code == 200) {
          this.delVisible = false
          this.pagination.page = 1
          this.getNewsList()
          this.$message.success(this.$t('admin.content.news.list.messages.deleteSuccess'))
        }
      })
    },
    async getNewsList(condition) {
      const data = {
        page: this.pagination.page,
        keyword: this.keyword,
        columnId: this.columnId,
        ...condition
      }
      const res = await newsList(data)
      if (res.code == 200) {
        this.data = getListIndex(res.data.list, this.pagination.page, this.pagination.pageSize)
        nameMap(this.data)
        this.pagination.total = res.data.total
        const permissionList = localStorage.permissionList
        this.noPermissionModal = !permissionList || !permissionList.includes('admin_news')
      }
    }
  },
  mounted() {
    this.columnId = this.$route.query.columnId
    this.getNewsList()
  }
}
</script>

<style lang="less" scoped>
.container{
  /deep/ .ant-table {
    min-height: 583px;
  }
  position: relative;
  .list-pagination{
    position: absolute;
    // bottom: 50px;
    width: calc(100% - 44px);
  }
}
h4{
  font-size: 16px;
  font-weight: 800;
  color: #000000;
  line-height: 22px;
  margin-bottom: 22px;
}
.admin{
  width: 100%;
  cursor: pointer;
  text-align: right;
  margin-bottom: 21px;
  .user-logo{
    width: 26px;
    height: 26px;
    border-radius: 100%;
    margin-right: 12px;
  }
  .down{
    width: 10px;
    margin-left: 5px;
  }
}
.selection{
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 22px;
  justify-content: space-between;
  /deep/.ant-input,
  /deep/.ant-input-affix-wrapper {
    width: 237px;
    height: 35px;
    color: #000;
    margin-right: 30px;
    border-radius: 20px;
    .ant-input-prefix,
    .ant-input-suffix{
      >img{
        width: 16px;
        cursor: pointer;
      }
    }
    .ant-input-suffix .clear{
      width: 14px;
      height: 14px;
    }
  }
}
.noData{
  display: flex;
  align-items: center;
  padding-bottom: 70px;
  flex-direction: column;
  justify-content: center;
  flex-direction: lab;
  height: calc(100% - 120px);
  img{
    width: 285px;
    margin-bottom: 12px;
  }
  > span{
    font-size: 14px;
    color: #0D2340;
    margin-top: -40px;
  }
  button{
    margin-top: 20px;
  }
}
/deep/.ant-input-suffix{
  right: 12px;
  img{
    width: 23px;
    cursor: pointer;
  }
}
/deep/.ant-form{
  .ant-form-item{
    margin-bottom: 22px;
    .ant-form-item-label{
      margin-bottom: 6px;
      line-height: normal !important;
    }
    &:last-child{
      margin-bottom: 0;
    }
  }
}
/deep/ .ant-btn.ant-btn-primary{
  width: auto;
}
</style>
